import api from './api';
import { handleApiError } from '../utils/apiErrors';

export const favoriteService = {
    getFavorites: async (userId) => {
        try {
            const response = await api.get(`/favorites/user/${userId}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    addFavorite: async (userId, productId) => {
        try {
            const response = await api.post('/favorites', { user_id: userId, product_id: productId });
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    removeFavorite: async (id) => {
        try {
            const response = await api.delete(`/favorites/${id}`);
            return response.data; // Likely empty or success message
        } catch (error) {
            return handleApiError(error);
        }
    }
};
